<div class="flex">
  <video
    class="video-js pillarbox-js"
    #container
    controls
    id="pillarbox-player"
  ></video>
</div>

<h5>Instructions</h5>
@if (status === "DONE") {
  <p-scrollPanel [style]="{ height: '400px' }">
    <markdown
      class="markdown my-1 line-height-3"
      [data]="text"
    />
  </p-scrollPanel>
} @else if (status === "ERROR") {
  <p-messages
    [value]="[{ severity: 'error', detail: 'Une erreure s\'est produite pendant la génération des instructions.' }]"
    closable="false"
  />
} @else if (status === "TRANSCRIBING" || status === "GENERATING_INSTRUCTIONS") {
  <p-messages
    [value]="[{ severity: 'info', detail: 'Veuillez patienter pendant la génération des instructions.' }]"
    closable="false"
  />
}
